import { ReactElement, useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { getRouteForbidden, getRouteHome, getRouteLogin, getRouteManageReadings } from "@/shared/const/routes";
import { useUser } from "@/entities/Auth";
import { UserRole } from "@/shared/const/userRole";

interface RequireAuthProps {
  children: ReactElement;
  roles?: UserRole[];
}

export function CheckAccess({ children, roles }: RequireAuthProps) {
  const location = useLocation();
  const user = useUser();

  const hasRequiredRoles = useMemo(() => {
    if (!user || !roles) {
      return false;
    }

    return roles.some((requiredRole) => user.role === requiredRole);
  }, [roles, user]);

  if (!roles) {
    return children;
  }

  if (!user) {
    return <Navigate replace to={getRouteLogin()} state={{ from: location }} />;
  }

  if (location.pathname === getRouteHome() && user.role === UserRole.Writer) {
    return <Navigate replace to={getRouteManageReadings()} state={{ from: location }} />;
  }

  if (!hasRequiredRoles) {
    return <Navigate replace to={getRouteForbidden()} state={{ from: location }} />;
  }

  return children;
}
